import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import { SearchOutlined } from '@mui/icons-material';
import { createSearchParams, NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateToView } from '../../../utils/date.utils';
import { useDispatch } from 'react-redux';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisProgressApi } from '../../../api/thesis-progress/thesis-progress.api';
import { routeName } from '../../../routes/routeName';
import StatusCustom from '../../../components/status/statusCustom';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import StateComponents from '../../../components/state-component/StateComponents';
import { debouncedApiCall } from '../../../utils/app.utils';
import { status_e_the_sis_data, thesis_progress_status_data } from '../../cms/EThesis/enum/enum';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import moment from 'moment';
import { advisorApi } from '../../../api/advisor/advisor.api';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';

export default function StudentsThesisProgress() {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("id_thesis_progress");
    const [sortType, setSortType] = useState<string>("DESC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };


    const [is_edit_advisor_request_name, set_is_edit_advisor_request_name] = useState<boolean>(false);
    const [advisor_request_name, set_advisor_request_name] = useState<string>("");
    const [can_send_progress, set_can_send_progress] = useState<boolean>(false);

    const [id_advisor_request, set_id_advisor_request] = useState<number | null>(null)
    const [start_date, set_start_date] = useState<string>("");
    const [end_date, set_end_date] = useState<string>("");
    const [status, set_status] = useState<{ label: string, value: string }>();



    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "ลำดับ",
        },
        {
            id: "leave_type_name",
            width: '400px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อวิทยานิพนธ์"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("วันที่ส่ง"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("เปอร์เซ็นต์ความคืบหน้า"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("สถานะ"),
        },


        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            class: matches && data?.length > 0,
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_thesis_progress, thesis_name, created_date, thesis_progress_percent, thesis_progress_status, student_no, degree_name, faculty_name, academic_year } =
            objData;

        const objRenderData = {
            key: id_thesis_progress,
            id: no,
            obj: objData,
            columns: [

                {
                    option: "TEXT",
                    align: "start",
                    label: no,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: thesis_name,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: created_date ?  dateToView(created_date) : '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: thesis_progress_percent || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: thesis_progress_status ? (
                        <StatusCustom
                            sx={{ maxWidth: 'fit-content', px: 2.5 }}
                            // white_space='nowrap'
                            text={thesis_progress_status === 'APPROVE' ? 'ผ่านการตรวจสอบ' : thesis_progress_status === 'WAITING' ? 'รอพิจารณา' : 'ไม่ผ่านการตรวจสอบ'}
                            type={thesis_progress_status === 'APPROVE' ? 'ผ่านการตรวจสอบ' : thesis_progress_status === 'WAITING' ? 'รอพิจารณา' : 'ไม่ผ่านการตรวจสอบ'} />
                    ) : '-'
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: (
                        <div className='flex justify-center items-center'>
                            <OptionsButtonCustom
                                enableView
                                enableSend={thesis_progress_status !== 'WAITING'}
                                enableEdit={thesis_progress_status === 'WAITING'}
                                enableDelete
                                onSendClick={() => {
                                    navigate(routeName.students.StudentsDateilThesisProgress.replace(':id', id_thesis_progress) + '?mode=SEND', {
                                        state: {
                                            advisor_request_name
                                        }
                                    })

                                }}
                                onViewClick={() => {
                                    navigate(routeName.students.StudentsDateilThesisProgress.replace(':id', id_thesis_progress) + '?mode=VIEW', {
                                        state: {
                                            advisor_request_name
                                        }
                                    })

                                }}
                                onEditClick={() => {
                                    navigate(routeName.students.StudentsDateilThesisProgress.replace(':id', id_thesis_progress) + '?mode=EDIT', {
                                        state: {
                                            advisor_request_name
                                        }
                                    })

                                }}
                                onDeleteClick={() => {
                                    id_thesis_progress && handleDelete(id_thesis_progress)
                                }}

                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };


    const handleSubmitAdvisorRequestName = async (id_advisor_request: number) => {
        dispatch(setLoading());
        await advisorApi.advisorUpdateNameWithEtheSis(id_advisor_request, { advisor_request_name: advisor_request_name }).then((res) => {
            if (res.status < 300) {
                set_is_edit_advisor_request_name(false);
                loadData();
                alertSuccess("อัพเดตชื่อวิทยานิพนธ์/ดุษฎีนิพนธ์์", "อัพเดตชื่อวิทยานิพนธ์/ดุษฎีนิพนธ์์ เรียบร้อย");
            }
        }).catch((err) => {
            alertError("อัพเดตชื่อวิทยานิพนธ์/ดุษฎีนิพนธ์์", "อัพเดตชื่อวิทยานิพนธ์/ดุษฎีนิพนธ์์ ไม่สำเร็จ");
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const loadData = useCallback(async () => {
        dispatch(setLoading());
        try {
            let condition: any = {
                sortBy,
                sortType
            };
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (start_date) condition.sdate = moment(start_date).format("YYYY-MM-DD");
            if (end_date) condition.edate = moment(end_date).format("YYYY-MM-DD");
            if (status) condition.status = status?.value;
            const res = await ThesisProgressApi.myThesisProgress(condition);
            const data = res.data
            if (data?.status < 300) {
                const advisor_request = data?.data?.advisor_request;
                if (advisor_request) {
                    set_can_send_progress(!!advisor_request?.advisor_request_name)
                    set_advisor_request_name(advisor_request?.advisor_request_name || "");
                    set_id_advisor_request(advisor_request?.id_advisor_request || null);
                }
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search, start_date, end_date, status]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleDelete = (id_thesis_progress: number) => {
        alertActive("ลบรายการ", "ต้องการลบรายการนี้หรือไม่?", undefined, undefined, async () => {
            await ThesisProgressApi.deleteList(id_thesis_progress).then((res: any) => {
                if (res.status < 300) {
                    alertSuccess(t('ลบเอกสาร เรียบร้อยแล้ว'))
                    loadData()
                }
            }).catch((error: any) => {
                console.log(error)
                alertError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })
        })

    }


    return (
        <div>
            <ContentHeading
                title={t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className='col-span-12 grid grid-cols-12 gap-4 my-6'>
                    <span className='col-span-12 xl:col-span-10'>
                        <StateComponents
                            typeProps={[
                                {
                                    seq: 1,
                                    gridProps: {
                                        xs: 12,
                                    },
                                    type: "TEXT_FIELD",
                                    fieldProps: {
                                        heading: "ชื่อวิทยานิพนธ์/ดุษฎีนิพนธ์์",
                                        placeholder: "ชื่อวิทยานิพนธ์/ดุษฎีนิพนธ์์",
                                        disabled: !is_edit_advisor_request_name,
                                        value: advisor_request_name,
                                        onChange: (e) => {
                                            set_advisor_request_name(e.target.value)
                                        }
                                    }
                                },
                            ]}
                        />
                    </span>
                    <span className='col-span-12 md:col-span-2 flex justify-end items-center pt-6'>
                        {is_edit_advisor_request_name ? (
                            <div className='flex gap-4 w-full'>
                                <Button onClick={() => {
                                    set_is_edit_advisor_request_name(false);
                                    loadData();
                                }} fullWidth variant='contained' color='error'>
                                    ยกเลิก
                                </Button>
                                <Button disabled={!advisor_request_name} onClick={() => id_advisor_request && handleSubmitAdvisorRequestName(id_advisor_request)} startIcon={<EditNoteOutlinedIcon />} color='success' fullWidth variant='contained'>
                                    ยืนยัน
                                </Button>
                            </div>
                        ) : (
                            <Button onClick={() => set_is_edit_advisor_request_name((prev) => !prev)} startIcon={<EditNoteOutlinedIcon />} color='secondary' fullWidth variant='contained'>
                                แก้ไข
                            </Button>
                        )}

                    </span>
                </article>
                <article className="w-full col-span-12 md:col-span-8">
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    startAdornment: <Box mr={1}><SearchOutlined /></Box>,
                                    placeholder: "ค้นหาชื่อเรื่อง",
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch })
                                }
                            },
                            {
                                seq: 2,
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                type: "DATE_RANGE2",
                                fieldProps: {
                                    placeholder: "ช่วงวันที่",
                                    handleChange: (st, end) => {
                                        set_start_date(st ?? "");
                                        set_end_date(end ?? "");
                                    },
                                    value: {
                                        end_date,
                                        start_date
                                    }
                                }
                            },
                            {
                                seq: 3,
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label || "",
                                    labelId: "DWAD",
                                    onChange: (_, val) => set_status(val ?? null),
                                    placeholder: "ทุกสถานะ",
                                    options: thesis_progress_status_data || [],
                                    value: status || null
                                }
                            },
                        ]}
                    />
                    {/* <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหาชื่อเรื่อง")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    /> */}
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <Button disabled={!can_send_progress || is_edit_advisor_request_name} variant='contained' color='success' onClick={() => {
                        navigate(routeName.students.StudentsAddThesisProgress, {
                            state: {
                                advisor_request_name
                            }
                        })
                    }} startIcon={<NearMeOutlinedIcon />}>
                        ส่งความคืบหน้า
                    </Button>
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>

        </div >
    )
}
